import { DetachedSearchWrapper, WideInputSearch } from '../../AudienceSelection.styled';
import { useAudienceContext } from '../../context';

export const SEARCH_PLACEHOLDER = 'Search by name or ID';
export const SEARCH_TEST_ID = 'list-input-search';

export const AudienceSelectionHeaderEligibility = () => {
  const { searchText, handleSearch } = useAudienceContext();

  return (
    <>
      <DetachedSearchWrapper>
        <WideInputSearch
          id={SEARCH_TEST_ID}
          data-test={SEARCH_TEST_ID}
          onChange={handleSearch}
          placeholder={SEARCH_PLACEHOLDER}
          value={searchText}
        />
      </DetachedSearchWrapper>
    </>
  );
};
